import script from "./BookingSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingSummary.vue?vue&type=script&setup=true&lang=js"

import "./BookingSummary.vue?vue&type=style&index=0&id=1dc2b42c&scoped=true&lang=scss"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dc2b42c"]])

export default __exports__